/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Paper,
  Typography,
  Divider,
  Tabs,
  Tab,
  Button,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";

import Add from "@material-ui/icons/Add";
import Delete from "@material-ui/icons/Delete";

import { v4 as uuidv4 } from 'uuid';

import Actions from "../../../fluid/Actions/ActionFactory";

import DataMarker from "./DataMarker/DataMarker";

import { allowedByOpop } from '../../Security/SecureCheck';

const clone = require("rfdc")();

const styles = (theme) => ({
  insetTab: {
    borderRight: `1px solid ${theme.palette.divider}`,
    width: "10%",
  },
});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

class SetDataMarkers extends Component {
  state = {
    data_marker_train: [],
    data_marker_predict: [],
    insetTabValue: 0,

    train_submitting: false,
    train_submit_success: false,
    train_submit_feedback_text: "",

    predict_submitting: false,
    predict_submit_success: false,
    predict_submit_feedback_text: "",
  };

  componentDidMount() {
    const headingHeight = this.heading.current.clientHeight;
    const contentHeight = this.props.maxHeight - headingHeight;
    this.setState({
      ...this.state,
      content_height: contentHeight,
      heading_height: headingHeight,
    });
  }

  heading = React.createRef();

  handleInsetTabChange = (event, value) => {
    this.setState({
      ...this.state,
      insetTabValue: value,
    });
  };

  renderInsetTabs = (insetTabValue) => {
    if (insetTabValue === 0) {
      return this.renderTrainTab();
    } else if (insetTabValue === 1) {
      return this.renderPredictTab();
    }
  };

  renderTrainTab = () => {
    return (
      <div style={{ padding: "5px", maxHeight: "100%", overflow: "scroll" }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            paddingRight: "10px",
            alignItems: "center",
          }}
        >
          <Typography
            style={{
              color: this.state.train_submit_success ? "#05AF1A" : "#dc004e",
              paddingRight: "5px",
            }}
            variant="caption"
          >
            {this.state.train_submit_feedback_text}
          </Typography>
          <ThemeProvider theme={blue_theme}>
            <Button
              disabled={
                !this.areDMsUnderTabReadyToBeSubmitted(
                  this.state.data_marker_train
                ) || !allowedByOpop({
                  operation : "/sainapse/information_channel/{ic_name}/information_unit/{name}/train_data_marker",
                  method : "POST",
                  operands : [
                    {
                      attrName: "ic_name",
                      value : this.props.ic_name
                    },
                    {
                      attrName: "name",
                      value : this.props.iu_name
                }]
                })
              }
              size="small"
              variant="contained"
              color="primary"
              startIcon={
                this.state.train_submitting ? (
                  <CircularProgress style={{ color: "#FFFFFF" }} size={20} />
                ) : null
              }
              onClick={this.submitDataMarkerTrain}
            >
              Submit Train Data Marker
            </Button>
          </ThemeProvider>
        </div>
        {this.renderTab(this.state.data_marker_train)}
        {this.renderButtons(this.state.insetTabValue)}
      </div>
    );
  };

  renderPredictTab = () => {
    return (
      <div style={{ padding: "5px", maxHeight: "100%", overflow: "scroll" }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "center",
            paddingRight: "10px",
          }}
        >
          <Typography
            style={{
              color: this.state.predict_submit_success ? "#05AF1A" : "#dc004e",
              paddingRight: "5px",
            }}
            variant="caption"
          >
            {this.state.predict_submit_feedback_text}
          </Typography>
          <ThemeProvider theme={blue_theme}>
            <Button
              disabled={
                !this.areDMsUnderTabReadyToBeSubmitted(
                  this.state.data_marker_predict
                ) || !allowedByOpop({
                  operation : "/sainapse/information_channel/{ic_name}/information_unit/{name}/predict_data_marker",
                  method : "POST",
                  operands : [
                    {
                      attrName: "ic_name",
                      value : this.props.ic_name
                    },
                    {
                      attrName: "name",
                      value : this.props.iu_name
                }]
                })
              }
              size="small"
              variant="contained"
              color="primary"
              startIcon={
                this.state.predict_submitting ? (
                  <CircularProgress style={{ color: "#FFFFFF" }} size={20} />
                ) : null
              }
              onClick={this.submitDataMarkerPredict}
            >
              Submit Predict Data Marker
            </Button>
          </ThemeProvider>
        </div>
        {this.renderTab(this.state.data_marker_predict)}
        {this.renderButtons(this.state.insetTabValue)}
      </div>
    );
  };

  renderTab = (selected_tab_data_markers) => {
    let data_markers = selected_tab_data_markers.map((dm, i) => {
      return (
        <DataMarker
          key={dm.id}
          index={i}
          type={this.state.insetTabValue === 0 ? "train" : "predict"}
          data_marker={dm}
          ic_name={this.props.ic_name}
          iu_name={this.props.iu_name}
          ws_name={this.props.ws_name}
          field_config = {{
            url : '/sainapse/information_channel/' + this.props.ic_name + '/information_unit/' + this.props.iu_name + '/fields_schema',
            method : "get",
            data : {},
            params : {}
          }}
          operator_config = {{
              url : '/sainapse/web_service/datamarker_operator',
              method : "get",
              data : {},
              params : {
                ws_name : this.props.ws_name
              }
          }}
          operator_params_config = {{
              url : '/sainapse/web_service/datamarker_operator/params',
              method : "get",
              data : {},
              params : {
                ws_name : this.props.ws_name
              }
          }}
          action_config = {{
              url : '/sainapse/web_service/datamarker_action',
              method : "get",
              data : {},
              params : {
                ws_name : this.props.ws_name
              }
          }}
          action_params_config = {{
              url : '/sainapse/web_service/datamarker_action/params',
              method : "get",
              data : {},
              params : {
                ws_name : this.props.ws_name
              }
          }}
          edit={true}
          pushDataMarker={(id, data_marker) =>
            this.pushDataMarker(id, data_marker)
          }
          removeDataMarker={(type, id) =>
            this.removeDataMarker(this.state.insetTabValue, type, id)
          }
          editDataMarker={(type, id) =>
            this.editDataMarker(this.state.insetTabValue, type, id)
          }
        />
      );
    });

    return data_markers;
  };

  renderButtons = (tabValue) => {
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <ThemeProvider theme={blue_theme}>
          <Tooltip title="Add Data Marker">
            <IconButton
              size="small"
              color="primary"
              onClick={() => this.addDataMarker(tabValue)}
              disabled={this.addDataMarkerDisabled(tabValue, this.props.ic_name, this.props.iu_name)}
            >
              <Add />
            </IconButton>
          </Tooltip>
        </ThemeProvider>
      </div>
    );
  };

  editDataMarker = (tabValue, type, id) => {
    if (tabValue === 0) {
      this.editDataMarkerTrain(type, id);
    } else if (tabValue === 1) {
      this.editDataMarkerPredict(type, id);
    }
  };

  editDataMarkerTrain = (type, id) => {
    let new_state = clone(this.state);
    let index = new_state.data_marker_train.findIndex((dm) => dm.id === id);
    new_state.data_marker_train[index].edit = true;
    this.setState({ ...new_state }, () =>
      console.log("Set DM State: ", this.state)
    );
  };

  editDataMarkerPredict = (type, id) => {
    let new_state = clone(this.state);
    let index = new_state.data_marker_predict.findIndex((dm) => dm.id === id);
    new_state.data_marker_predict[index].edit = true;
    this.setState({ ...new_state }, () =>
      console.log("Set DM State: ", this.state)
    );
  };

  pushDataMarker = (id, dm) => {
    let new_state = clone(this.state);
    if (this.state.insetTabValue === 0) {
      let index = new_state.data_marker_train.findIndex((dm) => dm.id === id);
      new_state.data_marker_train[index] = dm;
      new_state.data_marker_train[index].edit = false;
      this.setState({ ...new_state }, () =>
        console.log("Set DM State: ", this.state)
      );
    } else if (this.state.insetTabValue === 1) {
      let index = new_state.data_marker_predict.findIndex((dm) => dm.id === id);
      new_state.data_marker_predict[index] = dm;
      new_state.data_marker_predict[index].edit = false;
      this.setState({ ...new_state }, () =>
        console.log("Set DM State: ", this.state)
      );
    }
  };

  submitDataMarkerTrain = () => {
    this.setState({ train_submitting: true, train_submit_feedback_text: "" });
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" +
        this.props.ic_name +
        "/information_unit/" +
        this.props.iu_name +
        "/train_data_marker",

      method: "post",
      data: {
        data_markers: this.state.data_marker_train,
      },
    })
      .then((res) => {
        console.log("Submit DM: ", res.data.result);
        this.setState({
          ...this.state,
          train_submit_success: true,
          train_submitting: false,
          train_submit_feedback_text:
            "Train Data Marker Submitted succesfully!",
        });
      })
      .catch((err) => {
        this.setState({
          ...this.state,
          train_submit_success: false,
          train_submitting: false,
          train_submit_feedback_text: "Train Data Marker Submit Failed!",
        });
      });
  };

  submitDataMarkerPredict = () => {
    this.setState({
      predict_submitting: true,
      predict_submit_feedback_text: "",
    });
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" +
        this.props.ic_name +
        "/information_unit/" +
        this.props.iu_name +
        "/predict_data_marker",

      method: "post",
      data: {
        data_markers: this.state.data_marker_predict,
      },
    })
      .then((res) => {
        console.log("Submit DM: ", res.data.result);
        this.setState({
          ...this.state,
          predict_submit_success: true,
          predict_submitting: false,
          predict_submit_feedback_text:
            "Predict Data Marker Submitted succesfully!",
        });
      })
      .catch((err) =>
        this.setState({
          ...this.state,
          predict_submit_success: false,
          predict_submitting: false,
          predict_submit_feedback_text: "Predict Data Marker Submit Failed!",
        })
      );
  };

  areDMsUnderTabReadyToBeSubmitted = (data_markers) => {
    try {
      let num_of_dm = data_markers.length;

      let dm_ready = [];

      for (let i = 0; i < num_of_dm; i++) {
        if (data_markers[i].edit === false) {
          dm_ready[i] = true;
        } else {
          dm_ready[i] = false;
        }
      }

      console.log("DM Ready: ", dm_ready);
      let falsy = dm_ready.filter((item) => item === false);
      console.log("Falsy: ", falsy);
      if (falsy.length === 0 && dm_ready.length !== 0) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      return false;
    }
  };

  submitEnabled = () => {
    return (
      this.areDMsUnderTabReadyToBeSubmitted(this.state.data_marker_train) ||
      this.areDMsUnderTabReadyToBeSubmitted(this.state.data_marker_predict)
    );
  };

  addDataMarker = (tabValue) => {
    if (tabValue === 0) {
      this.addDataMarkerTrain();
    } else if (tabValue === 1) {
      this.addDataMarkerPredict();
    }
  };

  addDataMarkerDisabled = (tabValue, icName, iuName) => {
    if (tabValue === 0) {
      return !allowedByOpop({
        operation : "/sainapse/information_channel/{ic_name}/information_unit/{name}/train_data_marker",
        method : "POST",
        operands : [
          {
            attrName: "ic_name",
            value : icName
          },
          {
            attrName: "name",
            value : iuName
      }]
      });
    } else if (tabValue === 1) {
      return !allowedByOpop({
        operation : "/sainapse/information_channel/{ic_name}/information_unit/{name}/predict_data_marker",
        method : "POST",
        operands : [
          {
            attrName: "ic_name",
            value : icName
          },
          {
            attrName: "name",
            value : iuName
      }]
      });
    }
  };

  addDataMarkerTrain = () => {
    let new_state = clone(this.state);
    let new_id = uuidv4()
    new_state.data_marker_train.push({
      id: new_id,
      edit: true,
      trigger: {},
      actions: [],
    });

    this.setState({ ...new_state });
  };

  addDataMarkerPredict = () => {
    let new_state = clone(this.state);
    let new_id = uuidv4()
    new_state.data_marker_predict.push({
      id: new_id,
      edit: true,
      trigger: {},
      actions: [],
    });

    this.setState({ ...new_state });
  };

  removeDataMarker = (tabValue, type, id) => {
    if (tabValue === 0) {
      this.removeDataMarkerTrain(type, id);
    } else if (tabValue === 1) {
      this.removeDataMarkerPredict(type, IDBDatabase);
    }
  };

  removeDataMarkerTrain = (type, id) => {
    let new_state = clone(this.state);
    let index = new_state.data_marker_train.findIndex((dm) => dm.id === id);
    new_state.data_marker_train.splice(index, 1);

    this.setState({ ...new_state });
  };

  removeDataMarkerPredict = (type, id) => {
    let new_state = clone(this.state);
    let index = new_state.data_marker_predict.findIndex((dm) => dm.id === id);
    new_state.data_marker_predict.splice(index, 1);

    this.setState({ ...new_state });
  };

  render() {
    const { classes } = this.props;
    return (
      <Paper elevation={0} square style={{ width: "100%", height: "100%" }}>
        <div style={{ width: "100%", height: "100%" }}>
          <div
            ref={this.heading}
            style={{
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-end",
              backgroundColor: "#F0F0F0",
              borderBottom: "1px solid rgba(0,0,0,0.12)",
              padding: "5px",
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Typography variant="h6">Set Data Markers</Typography>
            </div>
            <ThemeProvider theme={blue_theme}>
              <Button
                style={{ marginLeft: "10px" }}
                size="small"
                variant="contained"
                color="primary"
                onClick={() => this.props.handleNext()}
              >
                {this.state.train_submit_success ||
                this.state.predict_submit_success
                  ? "Next"
                  : "Skip"}
              </Button>
            </ThemeProvider>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              height: this.state.content_height,
              overflow: "hidden",
            }}
          >
            <div className={classes.insetTab}>
              <ThemeProvider theme={blue_theme}>
                <Tabs
                  orientation="vertical"
                  value={this.state.insetTabValue}
                  onChange={this.handleInsetTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  centered
                >
                  <Tab label="Train" />
                  <Tab label="Predict" />
                </Tabs>
              </ThemeProvider>
            </div>
            <div
              style={{
                flexGrow: 1,
                height: "100%",
                overflow: "hidden",
                backgroundColor: "#ffffff",
              }}
            >
              {this.renderInsetTabs(this.state.insetTabValue)}
            </div>
          </div>
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(SetDataMarkers);
